<script setup lang="ts">
import DataLoading from '@/components/DataLoading.vue'
import Navigation from '@/components/Navigation.vue'
import { useAppReady } from '@/composables/useAppReady'
import { useZendeskAuthSync } from '@/composables/useZendeskWidget'
import { LToastProvider } from '@repo/lui'
import { VueQueryDevtools } from '@tanstack/vue-query-devtools'
import { useHead } from '@unhead/vue'

const isDevDomain = window.location.hostname.includes('lykadev.com.au')
const zendeskAllowedHost = import.meta.env.DEV || isDevDomain
const { error, isLoading, isReady, retry } = useAppReady()

useZendeskAuthSync({ allowedHost: zendeskAllowedHost })

useHead({
  titleTemplate: '%s - Lyka account',
  meta: isDevDomain ? [{ name: 'robots', content: 'noindex, nofollow' }] : [],
})
</script>

<template>
  <LToastProvider position="bottom-center" />
  <div class="flex min-h-dvh flex-col-reverse md:flex-col">
    <Navigation />

    <main class="flex grow flex-col">
      <DataLoading v-if="!isReady" :loading="isLoading" :error="error" fullpage variant="spinner" @try-again="retry" />
      <router-view v-else v-slot="{ Component }">
        <component :is="Component" ref="mainContent" />
      </router-view>
      <VueQueryDevtools v-if="false" />
    </main>
  </div>
</template>
